<template>
  <section class="section">
    <div class="container">
      <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo" />
      <b-switch class="switch-filtros" v-model="activarFiltros" :rounded="false">Activar Filtros</b-switch>
      <div v-if="activarFiltros" class="box">
        <div class="title is-5">Filtros</div>

        <div class="columns is-multiline">
          <div class="column is-12">
            <b-message type="is-warning">
              En los filtros del tipo
              <strong>"Exacto"</strong>, el campo se filtrará buscando que
              <u>
                <i>coincida exactamente</i>
              </u> con lo ingresado.
              <br />En los filtros del tipo
              <strong>"Parcial"</strong>, el campo se filtrará buscando que
              <u>
                <i>contenga</i>
              </u> el texto ingresado.
            </b-message>
          </div>
          <div class="column is-4">
            <b-field label="Usuario" message="Tipo: Exacto">
              <b-input v-model="filtros.usuario.valor" @keyup.enter.native="recuperarPedidos()"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field label="Nombre" message="Tipo: Parcial">
              <b-input v-model="filtros.nombre.valor" @keyup.enter.native="recuperarPedidos()"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field label="Apellido" message="Tipo: Parcial">
              <b-input v-model="filtros.apellido.valor" @keyup.enter.native="recuperarPedidos()"></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label="Estado">
              <b-select placeholder="Seleccionar Estado" v-model="filtros.estado.valor">
                <option
                  v-for="estado in constantes.pedidos.estados"
                  :value="estado"
                  :key="estado"
                >{{ estado | eliminarGuionesBajos }}</option>
                <option value>TODOS</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label="Tipo">
              <b-select placeholder="Seleccionar Tipo" v-model="filtros.tipo.valor">
                <option
                  :value="constantes.pedidos.tipos.TRADICIONAL.textoEntidad"
                >{{ constantes.pedidos.tipos.TRADICIONAL.textoEntidad | eliminarGuionesBajos }}</option>
                <option
                  :value="constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad"
                >{{ constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad | eliminarGuionesBajos }}</option>
                <option
                  :value="constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad"
                >{{ constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad | eliminarGuionesBajos }}</option>
                <option
                  :value="constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad"
                >{{ constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad | eliminarGuionesBajos }}</option>
                <option value>TODOS</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-5">
            <b-button
              class="boton-buscar"
              type="is-secundary"
              :loading="loading"
              @click="recuperarPedidos()"
              icon-left="magnify"
            >Buscar</b-button>
          </div>
        </div>
      </div>
      <b-table
        :data="data"
        :loading="loading"
        paginated
        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        detailed
        detail-key="id"
        :show-detail-icon="showDetailIcon"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" :width="10">{{ props.row.id }}</b-table-column>

          <b-table-column field="tipo" label="Tipo" :width="250">
            <b-taglist attached>
              <b-tag
                :type="typeTagTipoPedido(props.row)"
              >{{ esCompraOnline(props.row.tipo) ? 'COMPRA ONLINE' : 'TRADICIONAL' }}</b-tag>
              <b-tag v-if="esCompraOnline(props.row.tipo)">
                <img height="24" width="24" src="@/assets/img/mp/isologo_mp.png" />
              </b-tag>
              <b-tag
                v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad"
              >
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.ENVIO_DOMICILIO.texto">
                  <b-icon icon="motorbike"></b-icon>
                </b-tooltip>
              </b-tag>
              <b-tag
                v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad"
              >
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.ENVIO_RESTO_DEL_PAIS.texto">
                  <b-icon icon="truck-delivery"></b-icon>
                </b-tooltip>
              </b-tag>
              <b-tag
                v-if="props.row.tipo === $constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad"
              >
                <b-tooltip :label="$constantes.pedidos.tiposEntrega.RETIRO_LOCAL.texto">
                  <b-icon icon="home"></b-icon>
                </b-tooltip>
              </b-tag>
            </b-taglist>
          </b-table-column>

          <b-table-column field="estado" label="Estado" :width="40">
            <span
              v-bind:class="{ 'is-success': props.row.estado === constantes.pedidos.estados.CARGANDO,
                              'is-danger': props.row.estado === constantes.pedidos.estados.CREADO,
                              'is-link': props.row.estado === constantes.pedidos.estados.PENDIENTE_PAGO,
                              'is-warning': props.row.estado === constantes.pedidos.estados.ENVIO_PENDIENTE,
                              'is-light': props.row.estado === constantes.pedidos.estados.PARA_RETIRO,
                              'is-info': props.row.estado === constantes.pedidos.estados.PROCESANDO,
                              'is-primary': props.row.estado === constantes.pedidos.estados.CERRADO }"
              class="tag"
            >{{ props.row.estado | eliminarGuionesBajos }}</span>
          </b-table-column>

          <b-table-column field="precio" label="Precio">
            <p class="is-size-7">${{ props.row.precio }}</p>
          </b-table-column>
          <b-table-column field="fechaemision" label="Fecha" :width="40" centered>
            <span
              class="tag"
            >{{ props.row.fechaEmision ? new Date(props.row.fechaEmision).toLocaleDateString() : '' }}</span>
          </b-table-column>

          <b-table-column field="usuario" label="Usuario">
            <p class="is-size-7">
            <strong>{{ props.row.usuario.username }}</strong>
            - {{ props.row.usuario.nombre }} {{ props.row.usuario.apellido }}
            </p>
          </b-table-column>

          <b-table-column field="nombreCompleto" label="Producto">
            <p v-if="props.row.nombreCompleto.includes('con Borde')" class="is-size-7 has-text-danger">{{ props.row.nombreCompleto }} - <strong>({{props.row.cantidadFotos}})</strong></p>
            <p v-else class="is-size-7">{{ props.row.nombreCompleto }} - <strong>({{props.row.cantidadFotos}})</strong></p>
          </b-table-column>
          <b-table-column label="Acciones">
            <b-tooltip
              label="Iniciar Impresión"
              type="is-light"
              v-if="props.row.estado === constantes.pedidos.estados.CREADO"
            >
              <b-button
                @click="imprimirPedido(props.row)"
                type="is-primary"
                size="is-small"
                icon-left="package-variant"
              ></b-button>
            </b-tooltip>
            <b-tooltip
              label="Finalizar Impresión"
              type="is-light"
              v-if="props.row.estado === constantes.pedidos.estados.PROCESANDO"
            >
              <b-button
                @click="finalizarImpresionPedido(props.row)"
                type="is-success"
                size="is-small"
                icon-left="cube-send"
              ></b-button>
            </b-tooltip>
            <b-tooltip
              label="Cerrar"
              type="is-light"
              v-if="props.row.estado === constantes.pedidos.estados.ENVIO_PENDIENTE ||
                    props.row.estado === constantes.pedidos.estados.PARA_RETIRO"
            >
              <b-button
                @click="cerrarPedido(props.row)"
                type="is-twitter"
                size="is-small"
                icon-left="package-variant-closed"
              ></b-button>
            </b-tooltip>
            <b-tooltip
              label="Cancelar"
              type="is-light"
              v-if="props.row.tipo && props.row.estado !== constantes.pedidos.estados.CERRADO &&
                    props.row.estado !== constantes.pedidos.estados.CANCELADO"
            >
              <b-button
                @click="cancelarPedido(props.row)"
                type="is-danger"
                size="is-small"
                icon-left="delete-outline"
              ></b-button>
            </b-tooltip>
          </b-table-column>
        </template>

        <template slot="footer">
          <div class="has-text-right">Total: {{total}}</div>
        </template>

        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <u>Telefono Usuario</u>
                  : {{props.row.usuario.telefono}}
                  <br />
                  <u>Dirección Usuario</u>
                  : {{props.row.usuario.direccion}}
                  <br />
                  <u>Provincia - Localidad Usuario</u>
                  : {{props.row.usuario.provincia}} - {{props.row.usuario.localidad}}
                  <br />
                  <u>Correo Electronico Usuario</u>
                  : {{props.row.usuario.email}}
                  <br />
                  <u>Tipo de Usuario</u>
                  : {{props.row.usuario.tipo}}
                  <br />
                  <u>Observaciones</u>
                  : {{props.row.observaciones}}
                  <br />
                  <u>Ruta del Pedido</u>
                  : {{rutaPedidos}}\{{props.row.usuario.username}}\Pedido [{{props.row.id }}]\
                  <template
                    v-if="props.row.tipo === constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad && props.row.datosEnvio"
                  >
                    <br />
                    <u>Datos Envío:</u>
                    : CP: {{ props.row.datosEnvio.codigoPostal }} - Calle: {{props.row.datosEnvio.calle}} - Altura: {{props.row.datosEnvio.altura}} - Piso: {{props.row.datosEnvio.piso}} - Dpto: {{props.row.datosEnvio.departamento}} - Teléfono: {{props.row.datosEnvio.telefono}} - Fecha: {{ (new Date(props.row.datosEnvio.fechaEntrega)).toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' }) }} - Turno: {{props.row.datosEnvio.turno}} - Obs: {{props.row.datosEnvio.observaciones ? props.row.datosEnvio.observaciones : ''}}
                  </template>
                  <template
                    v-if="props.row.tipo === constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad && props.row.datosEnvio === null"
                    >
                     <br />
                    <u>Datos Envío:</u> <strong>Al usuario le falta cargar los datos de envío.</strong>
                  </template>
                </p>
              </div>
            </div>
          </article>
        </template>
      </b-table>
    </div>
  </section>
</template>

<style scoped>
.switch-filtros {
  margin-bottom: 0.6rem;
}
.boton-buscar {
  margin-top: 2rem;
}
</style>

<script>
import { mapState } from 'vuex'

import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  data () {
    return {
      titulo: 'Administrador',
      subtitulo: 'Listado de pedidos',
      tiempoRefrescoTabla: process.env.VUE_APP_TIEMPO_MS_REFRESCO_TABLA_ADMIN,
      intervalRefresco: '',
      activarFiltros: true,
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      constantes: this.$constantes,
      rutaPedidos: process.env.VUE_APP_RUTA_PEDIDOS,
      filtros: {
        usuario: {
          nombre: 'username',
          valor: ''
        },
        nombre: {
          nombre: 'usuario.nombre',
          valor: ''
        },
        apellido: {
          nombre: 'usuario.apellido',
          valor: ''
        },
        estado: {
          nombre: 'estado',
          valor: ''
        },
        tipo: {
          nombre: 'tipo',
          valor: ''
        }
      }
    }
  },
  components: {
    TituloPrincipal
  },
  methods: {
    typeTagTipoPedido (pedido) {
      if (this.esCompraOnline(pedido.tipo) && pedido.estado !== this.constantes.pedidos.estados.CREADO) {
        return 'is-info'
      } else if (this.esCompraOnline(pedido.tipo) && pedido.estado === this.constantes.pedidos.estados.CREADO) {
        return 'is-success'
      }
    },
    esCompraOnline (tipoPedido) {
      let esCompraOnline = true
      if (
        tipoPedido === this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad
      ) {
        esCompraOnline = false
      }
      return esCompraOnline
    },
    prepararPedidoParaEdit (pedido) {
      const copiaPedido = {
        '@id': pedido['@id'],
        '@type': pedido['@type'],
        id: pedido.id
      }
      return copiaPedido
    },
    imprimirPedido (pedido) {
      this.$buefy.dialog.confirm({
        title: 'Iniciar Impresión',
        message: `¿Estas seguro que deseas <b>iniciar la impresión</b> del pedido [${pedido.id}]? Esta acción no puede deshacerse`,
        confirmText: 'Iniciar Impresión',
        type: 'is-primary',
        hasIcon: true,
        icon: 'package-variant',
        onConfirm: () => {
          const pedidoEditado = this.prepararPedidoParaEdit(pedido)
          pedidoEditado.estado = this.constantes.pedidos.estados.PROCESANDO
          this.loading = true
          this.$apiService
            .editPedido(pedidoEditado)
            .then(response => {
              this.$buefy.toast.open({
                message: `Pedido [${pedido.id}] Para Imprimir`,
                type: 'is-success'
              })
              this.recuperarPedidos()
            })
            .catch(error => {
              this.mensajeErrorAxios(error, this)
              this.loading = false
            })
        }
      })
    },
    cancelarPedido (pedido) {
      this.$buefy.dialog.confirm({
        title: 'Cancelar Pedido',
        message: `¿Estas seguro que deseas <b>cancelar</b> el pedido [${pedido.id}]? Esta acción no puede deshacerse`,
        confirmText: 'Cancelar Pedido',
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete-outline',
        onConfirm: () => {
          const pedidoEditado = this.prepararPedidoParaEdit(pedido)
          pedidoEditado.estado = this.constantes.pedidos.estados.CANCELADO
          this.loading = true
          this.$apiService
            .editPedido(pedidoEditado)
            .then(response => {
              this.$buefy.toast.open({
                message: `Pedido [${pedido.id}] Cancelado`,
                type: 'is-success'
              })
              this.recuperarPedidos()
            })
            .catch(error => {
              this.mensajeErrorAxios(error, this)
              this.loading = false
            })
        }
      })
    },
    finalizarImpresionPedido (pedido) {
      this.$buefy.dialog.confirm({
        title: 'Finalizar Impresión Pedido',
        message: `¿Estas seguro que deseas <b>finalizar impresión</b> del pedido [${pedido.id}]? Esta acción no puede deshacerse`,
        confirmText: 'Finalizar Impresión Pedido',
        type: 'is-success',
        hasIcon: true,
        icon: 'cube-send',
        onConfirm: () => {
          const pedidoEditado = this.prepararPedidoParaEdit(pedido)
          // Controla si es con envio o no
          if (
            pedido.tipo ===
            this.constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS
              .textoEntidad ||
            pedido.tipo ===
            this.constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO
              .textoEntidad
          ) {
            pedidoEditado.estado = this.constantes.pedidos.estados.ENVIO_PENDIENTE
          } else {
            pedidoEditado.estado = this.constantes.pedidos.estados.PARA_RETIRO
          }
          this.loading = true
          this.$apiService
            .editPedido(pedidoEditado)
            .then(response => {
              this.$buefy.toast.open({
                message: `Impresión de pedido [${pedido.id}] finalizada`,
                type: 'is-success'
              })
              this.recuperarPedidos()
            })
            .catch(error => {
              this.mensajeErrorAxios(error, this)
              this.loading = false
            })
        }
      })
    },
    cerrarPedido (pedido) {
      this.$buefy.dialog.confirm({
        title: 'Cerrar Pedido',
        message: `¿Estas seguro que deseas <b>cerrar</b> el pedido [${pedido.id}]? Esta acción no puede deshacerse`,
        confirmText: 'Cerrar Pedido',
        type: 'is-twitter',
        hasIcon: true,
        icon: 'package-variant-closed',
        onConfirm: () => {
          const pedidoEditado = this.prepararPedidoParaEdit(pedido)
          pedidoEditado.estado = this.constantes.pedidos.estados.CERRADO
          this.loading = true
          this.$apiService
            .editPedido(pedidoEditado)
            .then(response => {
              this.$buefy.toast.open({
                message: `Pedido [${pedido.id}] cerrado`,
                type: 'is-success'
              })
              this.recuperarPedidos()
            })
            .catch(error => {
              this.mensajeErrorAxios(error, this)
              this.loading = false
            })
        }
      })
    },
    /*
     * Recupera los pedidos asincronicamente
     */
    recuperarPedidos () {
      this.loading = true
      var componenteVue = this

      function postGetPedidos (error, data) {
        if (error) {
          componenteVue.data = []
          componenteVue.total = 0
          componenteVue.loading = false
          componenteVue.$buefy.dialog.alert({
            title: 'Error - ' + error.response.data.status,
            message: error.response.data.message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'close-circle-outline',
            iconPack: 'mdi'
          })
        } else {
          componenteVue.data = data['hydra:member']
          componenteVue.total = data['hydra:totalItems']
          componenteVue.loading = false
        }
      }

      const filtros = []

      if (this.activarFiltros) {
        const keysFiltros = Object.keys(this.filtros)
        for (let i = 0; i < keysFiltros.length; i++) {
          const key = keysFiltros[i]
          if (this.filtros[key].valor !== '') {
            const filtro = {
              nombre: this.filtros[key].nombre,
              valor: this.filtros[key].valor
            }
            filtros.push(filtro)
          }
        }
      }
      this.$apiService.getPedidosAdmin(
        this.perPage,
        this.page,
        this.activarFiltros,
        filtros,
        postGetPedidos
      )
    },
    /*
     * Maneja el paginado cuando cambia de pagina
     */
    onPageChange (page) {
      this.page = page
      this.recuperarPedidos()
    }
  },
  computed: {
    ...mapState(['usuarioLogueado'])
  },
  mounted () {
    this.recuperarPedidos()
    this.intervalRefresco = setInterval(function () {
      this.recuperarPedidos()
    }.bind(this), this.tiempoRefrescoTabla)
  },
  beforeDestroy () {
    clearInterval(this.intervalRefresco)
  }
}
</script>
